<nav class="toolbar navbar navbar-light" autocomplete="off">
    <form class="form-inline">
        <button *ngIf="!visibilitySpinner" type="button" title="Exportar" [disabled]="!resultMrn?.ResultList || resultMrn?.ResultList?.length === 0" class="btn btn-outline-success" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Buscador de MRNs</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">
                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpMrn">MRN</label>
                                    <input formControlName="Mrn" name="Mrn" class="form-control" id="inpMrn" inputStyleClass="form-control" [ngClass]="displayFieldCss('Mrn')" type="text" maxlength="18" value="">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Mrn','required')">
                                        El MRN no puede estar vacío para realizar la búsqueda.
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="button" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--https://medium.com/@schneidenbach/restful-api-best-practices-and-common-pitfalls-7a83ba3763b5-->
        <!--https://stackoverflow.com/questions/46434313/angular-4-async-with-loading-and-display-when-empty-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de MRNs de Importación
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultMrn?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" sortField="Mrn" [rows]="resultMrn?.PageSize" [totalRecords]="resultMrn?.TotalCount" [loading]="loading"
                                 [ngClass]="displayGridHidden(resultMrn?.ResultList)"
                                 styleClass="table table-responsive-sm  table-striped table-sm">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="col.field!=='Link' && col.field!=='Image' && col.field!=='FechaPresentacion'">{{rowData[col.field]}}</span>
                                        <span *ngIf="col.field==='FechaPresentacion'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <button (click)="onEdit(rowData)" type="button" title="Consultar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-search"></span>

                                            </button>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
